<template>
    <BaseMapShell v-model:panelOpen="panelOpen" v-model:rightPanelOpen="rightPanelOpen" :center="center" :zoom="zoom"
        :bounds="bounds" :max-bounds="maxBounds" :minZoom="3" :maxZoom="19" :enableCorridorings="true">
        <!-- Calques spécifiques -->
        <template v-if="positions">
            <l-control position="bottomleft">
                <div class="row mb-2 mx-2 px-1">
                    <div class="col-auto badge blue-square text-white text-decoration-none small text-nowrap">
                        0-50 km/h
                    </div>
                </div>
                <div class="row my-2 mx-2 px-1">
                    <div class="badge orange-square text-white text-decoration-none small text-nowrap">
                        50-90 km/h
                    </div>
                </div>
                <div class="row mt-2 mx-2 px-1">
                    <div class="badge red-square text-white text-decoration-none small text-nowrap">
                        90+ km/h
                    </div>
                </div>
            </l-control>

            <CorridoringLayer
                v-if="showCorridoring && corridoringPositions.length"
                :positions="corridoringPositions"
                :geofencings="corridoringGeofencings"
                :show-radius="true"
            />

            <AlarmMarker v-for="alarm in alarms" :key="alarm.id" :alarm="alarm" />
            <SpeedPolylineLayer :polyline-data="polylineData" />
        </template>

        <!-- Right panel mission (optionnel) -->
        <template #right-panel>
            <RightMissionPanel
                v-if="mission && mission.id"
                :mission="mission"
                v-model:showCorridoring="showCorridoring"
            />
        </template>
    </BaseMapShell>
</template>

<script>
import { LControl } from "@vue-leaflet/vue-leaflet";
import BaseMapShell from "../BaseMapShell.vue";
import RightMissionPanel from "../Components/rightPanel/RightMissionPanel.vue";
import AlarmMarker from "../Components/AlarmMarker.vue";
import PositionService from '@/services/position.service.js'
import AlarmService from '@/services/alarm.service.js'
import MissionRepository from '@/repositories/mission.repo.js'
import FormatHelper from '@/helpers/format.helper.js'
import SpeedPolylineLayer from "../Components/SpeedPolylineLayer.vue";
import CorridoringLayer from "../Components/layers/CorridoringLayer.vue";
import CorridoringService from "@/services/corridoring.service.js";
import { getPolylineDataFromPositions } from "../composables/usePolyline";
import { computePaddedBounds } from "../composables/useBounds";
import { normalizePositions } from "../composables/usePositions";

export default {
    components: {
        BaseMapShell,
        RightMissionPanel,
        AlarmMarker,
        LControl,
        SpeedPolylineLayer,
        CorridoringLayer
    },
    data() {
        return {
            panelOpen: false,
            rightPanelOpen: true,
            zoom: 13,
            center: [48.9571487, 2.1941876],
            bounds: [],
            maxBounds: [],
            mission: {},
            positions: [],
            alarms: [],
            polylineData: {},
            showCorridoring: true,
            corridoringPositions: [],
            corridoringGeofencings: [],
        };
    },
    mounted() {
        this.getMissionInfos();
    },
    methods: {
        async getMissionInfos() {
            try {
                this.mission = await MissionRepository.getMission(this.$route.params.id);
                this.getPositions();
                this.getAlarms();
                this.getCorridoringFullData();
            } catch (e) {
                console.log(e);
            }
        },
        getPositions() {
            PositionService.getBalisePositions(this.mission.transporteurId, 0, 3000, this.mission.startDate, this.mission.endDate)
                .then(response => {
                    const raw = FormatHelper.balisePingsFormat(response.data.filter(Array));
                    this.positions = normalizePositions(raw);
                    this.bounds = computePaddedBounds(this.positions, this.rightPanelOpen);
                    this.polylineData = getPolylineDataFromPositions(this.positions);
                })
        },
        getAlarms() {
            AlarmService.getBaliseAlarms(this.mission.transporteurId, 0, 500, this.mission.startDate, this.mission.endDate)
                .then(response => {
                    this.alarms = FormatHelper.baliseAlertsFormat(response.data.rows);
                })
        },
        async getCorridoringFullData() {
            const corridoringId = this.mission?.corridoringId || this.mission?.corridoring?.id;

            if (!corridoringId) {
                this.corridoringPositions = [];
                this.corridoringGeofencings = [];
                return;
            }

            try {
                const response = await CorridoringService.getCorridoringFullData(corridoringId);
                const data = response?.data || {};

                this.corridoringPositions = normalizePositions(data.corridoringPositions || []);
                this.corridoringGeofencings = Array.isArray(data.geofencings) ? data.geofencings : [];
            } catch (e) {
                console.log(e);
                this.corridoringPositions = [];
                this.corridoringGeofencings = [];
            }
        },
    }
}
</script>

<style>
.blue-square {
    background-color: #0d6efd;
    opacity: 0.65;
}

.orange-square {
    background-color: #ed8702;
    opacity: 0.65;
}

.red-square {
    background-color: #ed0202;
    opacity: 0.65;
}
</style>